// 判断当前访问平台platform的工具类
export class JudgmentPlatform {
    static getPlatform(): string {
        const userAgent = window.navigator.userAgent;
        if (userAgent.includes('Mobile CGTN/iOSBrowser') && !userAgent.includes('DarkMode') && userAgent.includes('JSBridgeSupport')) {
            return 'IOS';
        } else if (userAgent.includes('CGTN/AndroidBrowser') && !userAgent.includes('DarkMode') && userAgent.includes('JSBridgeSupport')) {
            return 'Android';
        } else if (userAgent.includes('CGTN/AndroidBrowserDarkMode') && userAgent.includes('JSBridgeSupport')) {
            return 'Android_dark';
        } else if (userAgent.includes('Mobile CGTN/iOSBrowserDarkMode') && userAgent.includes('JSBridgeSupport')) {
            return 'IOS_dark';
        } else if (userAgent.includes('Android')) {
            return 'Android_web';
        } else if (userAgent.includes('iPhone') || userAgent.includes('iPad') ||
            userAgent.includes('iPod')) {
            return 'IOS_web';
        } else if (userAgent.includes('Windows')) {
            return 'Windows';
        } else if (userAgent.includes('Macintosh')) {
            return 'macOS';
        } else {
            return 'Unknown';
        }
    }

    // 判断是否是在手机浏览器上
    static isMobileBrowser(): boolean {
        const platform = this.getPlatform();

        return platform === 'IOS_web' || platform === 'Android_web';
    }

    // 自动判断是否是在CGTN的APP上登录的
    static isCGTNAPPAutoJudge(): boolean {
        const platform = this.getPlatform();

        return platform === 'Android' || platform === "Android_dark" || platform === "IOS_dark" || platform === 'IOS';
    }

    static isMobile(platform: string): boolean {
        return platform === 'Android' || platform === "Android_dark" || platform === "IOS_dark" || platform === 'IOS';
    }
}